import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
} from "@angular/core";
import { GTemplateDirective } from "../directives/template/template.directive";
import { ObjectUtils } from "../utils/objectUtils";
import { AbstractControl, FormControl } from "@angular/forms";

// tslint:disable-next-line:no-conflicting-lifecycle
@Component({
  selector: "g-multiselect",
  template: `<div
  class="g-multiselect g-multiselect--outline g-multiselect--rounded"
  g-outside
  (clickOutside)="focused = false"
  (click)="touched = true; control.markAsTouched()"
  [class.focused]="focused && !readonly"
  [class.readonly]="readonly"
  [class.invalid]="(touched || control.touched) && control.invalid"
>
  <div class="g-multiselect-label-container" (click)="onMouseClick($event)">
    <span class="g-multiselect-label g-corner-all">
      <ng-container *ngIf="!selectedItemsTemplate"
        ><div>{{ valuesAsString }}</div>
      </ng-container>
      <ng-container *ngIf="(!value || !value.length) && selectedItemsTemplate">
        <div>{{ valuesAsString }}</div>
      </ng-container>
      <ng-container
        *ngTemplateOutlet="selectedItemsTemplate; context: { $implicit: value }"
      ></ng-container>
    </span>
    <div class="g-multiselect-icon">
      <mat-icon>expand_more</mat-icon>
    </div>
  </div>
  <div class="g-multiselect-dropdown" *ngIf="focused && !readonly">
    <ng-container *ngFor="let option of options">
      <g-multiselect-item
        [option]="option"
        [selected]="isSelected(option)"
        (onClick)="onOptionClick($event)"
        [template]="itemTemplate"
        [label]="getOptionLabel(option)"
      ></g-multiselect-item>
    </ng-container>
  </div>
</div>
`,
  styles: [`@-webkit-keyframes placeholder-glow{50%{opacity:.2}}@-webkit-keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0;mask-position:-200% 0}}b,b.g-typography,strong,strong.g-typography{font-weight:600}a,a.g-typography{color:var(--color-darkBlue-500);text-decoration:none}.g-typography--large{margin-bottom:.5em;font-size:2.125rem;line-height:1.4;font-weight:700}.g-typography--title1,h1,h1.g-typography--title{margin-bottom:.5em;font-size:1.75rem;line-height:1.4;font-weight:700}.g-typography--title2,h2,h2.g-typography--title{margin-bottom:.5em;font-size:1.375rem;line-height:1.4;font-weight:700}.g-typography--title3,h3,h3.g-typography--title{margin-bottom:.5em;font-size:1.25rem;line-height:1.4;font-weight:600}.g-typography--body{margin-bottom:.5em;font-size:1rem;line-height:1.4;font-weight:400}.g-typography--headline{margin-bottom:.5em;font-size:1.0625rem;line-height:1.4;font-weight:600}.g-typography--subHeadline{margin-bottom:.5em;font-size:.9375rem;line-height:1.4;font-weight:400}.g-typography--small{margin-bottom:.5em;font-size:.8125rem;line-height:1.4;font-weight:400}.g-typography--caption{margin-bottom:.5em;font-size:.75rem;line-height:1.4;font-weight:400}.g-menu-item{display:flex;position:relative;align-items:center;justify-content:flex-start;overflow:hidden;padding:0 16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0;border:none;-webkit-tap-highlight-color:transparent;cursor:pointer;width:100%;text-align:left;box-sizing:border-box;color:inherit;font-size:inherit;background:0 0;text-decoration:none;margin:0;min-height:48px}.g-menu-item:hover:not([disabled]){background:rgba(0,0,0,.04)}.g-menu-item[disabled]{cursor:default;opacity:.38}.g-placeholder{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;width:100%;background-color:var(--color-grey-500);opacity:.5}.g-placeholder.btn::before{display:inline-block;content:""}.g-placeholder-small{min-height:16px}.g-placeholder-standard{min-height:24px}.g-placeholder-glow .g-placeholder{-webkit-animation:2s ease-in-out infinite placeholder-glow;animation:2s ease-in-out infinite placeholder-glow}@keyframes placeholder-glow{50%{opacity:.2}}.g-placeholder-wave{-webkit-mask-image:linear-gradient(130deg,#000 25%,rgba(0,0,0,.8) 75%,#000 55%);mask-image:linear-gradient(130deg,#000 25%,rgba(0,0,0,.8) 75%,#000 55%);-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-animation:2s linear infinite placeholder-wave;animation:2s linear infinite placeholder-wave}@keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0;mask-position:-200% 0}}.g-multiselect{min-height:60px;padding:0 16px;background:#fff;position:relative;min-width:108px;cursor:pointer}.g-multiselect-label-container{padding:19.5px 0;position:relative;height:100%}.g-multiselect-label-container .g-multiselect-label,.g-multiselect-label-container label{color:var(--color-grey-500);transition:.4s;overflow-x:hidden;width:calc(100% - 25px);color:var(--color-grey-900);white-space:nowrap;font-size:.9375rem;line-height:1.4;font-weight:600;margin:0}.g-multiselect.invalid{border-color:var(--color-red-500)}.g-multiselect.active label,.g-multiselect.focused label{top:18px}.g-multiselect.disabled{background:#f9f9f9}.g-multiselect .g-select-value{display:flex;flex-wrap:wrap;margin:0 -4px}.g-multiselect .g-select-value ::ng-deep .g-select-value-item{padding:4px}.g-multiselect.readonly .g-select-value{color:var(--color-grey-600)}.g-multiselect--fill{box-shadow:0 1.00267px 0 #e6e6e6;transition:.4s}.g-multiselect--fill.focused{box-shadow:0 1.00267px 0 var(--color-primary)}.g-multiselect--outline{border:1px solid;border-color:var(--color-grey-200)}.g-multiselect--outline.focused{border-color:var(--color-primary)}.g-multiselect-icon{position:absolute;top:50%;-webkit-transform:translateY(-50%);max-width:25px;right:0;display:inline-flex;color:var(--color-grey-400);transform:translateY(-50%)}.g-multiselect--rounded{border-radius:12px}.g-multiselect--clear.g-multiselect-form-field{padding-right:25px}.g-multiselect .g-input-reset{position:absolute;right:0;top:30px;-webkit-transform:translateY(-50%);transform:translateY(-50%);display:inline-flex;cursor:pointer}.g-multiselect .g-input-reset mat-icon{font-size:16px;height:16px;width:16px;line-height:16px}.g-multiselect-placeholder{color:var(--color-grey-500);margin:0}.g-multiselect-dropdown{position:absolute;top:calc(100% + 4px);left:0;width:100%;z-index:55;padding:5px 0;border-radius:12px;max-height:300px;overflow-y:auto;background:var(--color-white);box-shadow:0 3px 6px -4px #0000001f,0 6px 16px #00000014,0 9px 28px 8px #0000000d}.g-multiselect-dropdown-item{padding:10px 16px;position:relative;color:var(--color-grey-700);display:flex;align-items:center}.g-multiselect-dropdown-item:hover{background:var(--color-grey-50)}.g-multiselect-dropdown-item mat-icon{margin-left:auto;display:none}.g-multiselect-dropdown-item-selected{color:var(--color-grey-400);background:var(--color-grey-100)!important}.g-multiselect-dropdown-item-selected mat-icon{position:absolute;right:16px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);color:var(--color-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block}`],
})
export class MultiSelectComponent
  implements OnInit, AfterContentInit, AfterViewInit
{
  @ContentChildren(GTemplateDirective, { descendants: true })
  templates!: QueryList<GTemplateDirective>;

  @Input() name: string | undefined;

  @Input() label: string | undefined;

  @Input() optionLabel: string | undefined;

  @Input() optionValue: string | undefined;

  @Input() readonly: boolean | undefined;

  @Input() dataKey: string;

  @Input() control: AbstractControl = new FormControl(null);

  @Input() get options(): any[] | undefined {
    return this._options;
  }

  set options(val: any[] | undefined) {
    this._options = val;
    this.updateLabel();
  }

  @Output() onChange: EventEmitter<any> = new EventEmitter();

  @Output() onFocus: EventEmitter<any> = new EventEmitter();

  @Output() onBlur: EventEmitter<any> = new EventEmitter();

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  public valuesAsString: string;

  public focused: boolean;

  public touched: boolean;

  public itemTemplate: TemplateRef<any> | undefined;

  public selectedItemsTemplate: TemplateRef<any> | undefined;

  private _options: any[] | undefined;

  public value: any[] | undefined | null;

  _defaultLabel = "Choose";

  @Input() set defaultLabel(val: string) {
    this._defaultLabel = val;
    this.updateLabel();
  }

  get defaultLabel(): string {
    return this._defaultLabel;
  }

  constructor(private _cdr: ChangeDetectorRef) {}

  ngOnInit() {}

  getOptionLabel(option: any) {
    return this.optionLabel
      ? ObjectUtils.resolveFieldData(option, this.optionLabel)
      : option && option.label !== undefined
      ? option.label
      : option;
  }

  getOptionValue(option: any) {
    return this.optionValue
      ? ObjectUtils.resolveFieldData(option, this.optionValue)
      : !this.optionLabel && option && option.value !== undefined
      ? option.value
      : option;
  }

  onOptionClick(event) {
    const option = event.option;
    if (option.disabled) {
      return;
    }

    const optionValue = this.getOptionValue(option);
    const selectionIndex = this.findSelectionIndex(optionValue);
    if (selectionIndex !== -1) {
      this.value = this.value.filter((val, i) => i !== selectionIndex);
    } else {
      this.value = [...(this.value ? this.value : []), optionValue];
    }
    this.control.setValue(this.value);
    this.updateLabel();
  }

  isSelected(option: any) {
    return this.findSelectionIndex(this.getOptionValue(option)) !== -1;
  }

  findSelectionIndex(val: any): number {
    let index = -1;

    if (this.value) {
      for (let i = 0; i < this.value.length; i++) {
        if (ObjectUtils.equals(this.value[i], val, this.dataKey)) {
          index = i;
          break;
        }
      }
    }

    return index;
  }

  updateLabel() {
    if (this.value && this.options && this.value.length) {
      let label = "";
      for (let i = 0; i < this.value.length; i++) {
        const itemLabel = this.findLabelByValue(this.value[i]);
        if (itemLabel) {
          if (label.length > 0) {
            label = label + ", ";
          }
          label = label + itemLabel;
        }
      }
      this.valuesAsString = label;
    } else {
      this.valuesAsString = this.defaultLabel;
    }
  }

  findLabelByValue(val: any): string {
    let label = null;

    for (let i = 0; i < this.options.length; i++) {
      const option = this.options[i];
      const optionValue = this.getOptionValue(option);

      if (
        (val == null && optionValue == null) ||
        ObjectUtils.equals(val, optionValue, this.dataKey)
      ) {
        label = this.getOptionLabel(option);
        break;
      }
    }

    return label;
  }

  onMouseClick(event: any) {
    // TODO:Hidden logic
    if (event.target && event.target.classList.contains("multiselect-remove")) {
      return;
    }
    this.focused = !this.focused;
  }

  ngAfterContentInit(): void {
    (this.templates as QueryList<GTemplateDirective>).forEach((item) => {
      switch (item.getType()) {
        case "item":
          this.itemTemplate = item.template;
          break;
        case "selectedItem":
          this.selectedItemsTemplate = item.template;
          break;
        default:
          this.itemTemplate = item.template;
          break;
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.control.value && this.options) {
      const selectedOption = this.options.filter((option) => {
        const optionValue = this.getOptionValue(option);
        return this.control.value.find((value) => {
          const valueValue = this.getOptionValue(value);
          return ObjectUtils.equals(optionValue, valueValue, this.dataKey);
        });
      });

      if (!selectedOption) {
        return;
      }
      selectedOption.forEach((item) => {
        this.onOptionClick({
          option: item,
          disabled: false,
        });
      });
      this._cdr.detectChanges();
    }
  }
}
